import ScrollManager from '../utils/scroll-manager';

export default function initFormFilters() {
    const formsFilters = document.querySelectorAll('.js-wrapper-form-filters');
    
    formsFilters.forEach((container: Element) => {
        new FormFilters(container);
    });
}

class FormFilters {
    private $el: Element;
    private $formFilters: HTMLElement | null;
    /**
     * Mettre à true pour voir les effets des filtres en live.
     * Définit par l'attribut `data-filters-live` sur le formulaire.
     * 
     * @type {boolean}
     */
    private filtersLive: boolean = false;
    
    constructor($el: Element) {
        this.$el = $el;
        this.$formFilters = this.$el.querySelector<HTMLElement>('.js-form-filters');
        
        if (this.$formFilters) {
            this.filtersLive = this.$formFilters.dataset.filtersIsLive !== undefined && this.$formFilters.dataset.filtersIsLive !== 'false';

            this.initFormFilters();
            this.updateCounterFilters();
        }
    }
    
    /**
    * Initialise le formulaire des filtres
    *
    * @return {void}
    */
    private initFormFilters(): void {
        const dropDownContents = this.$formFilters?.querySelectorAll('.js-dropdown-content');
        const resetAllFiltersBtn = this.$el.querySelectorAll('.js-reset-filters');
        const btnOpenFiltresMobile = this.$el.querySelector('.js-btn-filters-mobile');
        const btnCloseFiltresMobile = this.$el.querySelector('.js-btn-close-filters-mobile');
        const checkFiltersDelete = this.$el.querySelectorAll('.js-check-filter-delete');
        const filterSearchOrder = document.querySelector('.js-filter-search-order');

        // Bouton reset dans un filtre
        dropDownContents?.forEach((dropDownContent: Element) => {
            const allCheckbox: NodeListOf<HTMLInputElement> | null = dropDownContent.querySelectorAll('input[type=checkbox]');
            const inputDate: HTMLInputElement | null = dropDownContent.querySelector('input[type=date]');
            const resetFiltersBtn = dropDownContent.querySelector('.js-reset-input-dropdown');
            if (resetFiltersBtn) {
                resetFiltersBtn.addEventListener('click', () => {
                    allCheckbox.forEach((checkbox: HTMLInputElement) => {
                        checkbox.checked = false;
                    });
                    if (inputDate) {
                        inputDate.value = '';
                    }

                    if (this.filtersLive) {
                        this.updateCounterFilters();
                    }
                });
            }
            
            allCheckbox.forEach((checkbox: HTMLInputElement) => {
                checkbox.addEventListener('change', () => {
                    if (this.filtersLive) {
                        this.updateCounterFilters();
                    }
                });
            });

            if (inputDate) {
                inputDate.addEventListener('change', () => {
                    if (this.filtersLive) {
                        this.updateCounterFilters();
                    }
                });
            }
        });
        
        // Bouton reset de tout les filtres
        if (resetAllFiltersBtn) {
            resetAllFiltersBtn.forEach((resetBtn: Element) => {
                resetBtn.addEventListener('click', () => {
                    if (this.$formFilters instanceof HTMLFormElement) {
                        const inputs: NodeListOf<HTMLInputElement> = this.$formFilters.querySelectorAll('input');
                        inputs.forEach((input: HTMLInputElement) => {
                            if (input.type === 'checkbox' || input.type === 'radio') {
                                input.checked = false;
                            } else {
                                input.value = '';
                            }
                        });
                        
                        if (this.filtersLive) {
                            this.updateCounterFilters();
                        }
                        this.$formFilters.submit();
                    }
                });
            });
        }
        
        // Bouton pour ouvrir le menu filtres en mobile
        if (btnOpenFiltresMobile) {
            btnOpenFiltresMobile.addEventListener('click', () => {
                if (this.$formFilters instanceof HTMLElement) {
                    this.$formFilters.classList.add('open');
                }
                ScrollManager.preventScroll(true);
            });
        }
        
        // Bouton pour fermer le menu filtres en mobile
        if (btnCloseFiltresMobile) {
            btnCloseFiltresMobile.addEventListener('click', () => {
                if (this.$formFilters instanceof HTMLElement) {
                    this.$formFilters.classList.remove('open');
                }
                ScrollManager.preventScroll(false);
            });
        }

        // Les tags des filtres sélectionnés
        
        if (checkFiltersDelete){
            checkFiltersDelete.forEach((checkFilterBtn: Element) => {
                checkFilterBtn.addEventListener('click', (evt: Event) => {
                    const element = evt.target as HTMLElement;
                    const input = document.querySelector('#'+element.dataset.inputId) as HTMLInputElement;
                    if (input) {
                        
                        if (input.type === 'checkbox') {
                            input.checked = false;
                        } else if (input.type === 'date') {
                            input.value = '';
                        }
                    }
                    
                    if (this.filtersLive) {
                        element.parentElement?.remove();
                        this.updateCounterFilters();
                    }
                    if (this.$formFilters instanceof HTMLFormElement) {
                        this.$formFilters.submit();
                    }
                });
            });
        }

        // Order filter by name asc|desc
        if (filterSearchOrder) {
            filterSearchOrder.addEventListener('change', (evt: Event) => {
                const element = evt.target as HTMLSelectElement;
                const inputOrder = document.querySelector('#filter-search-order') as HTMLInputElement;
                if (inputOrder) {
                    inputOrder.value = element.value;
                }
                if (this.filtersLive) {
                    this.updateCounterFilters();
                }
                if (this.$formFilters instanceof HTMLFormElement) {
                    this.$formFilters.submit();
                }
            });
        }
    }
    
    
    /**
    * Mise à jour du compteur des filtres avec checkbox
    *
    * @return {void}
    */
    private updateCounterFilters(): void {
        const dropDownContainers = this.$formFilters?.querySelectorAll('.js-dropdown-container');
        const boutonFiltresMobile = this.$el.querySelector('.js-btn-filters-mobile');
        const counterAllNumber = this.$el.querySelector('.nb-selected-all-checkbox');
        const resetAllFiltersBtn = this.$el.querySelectorAll('.js-reset-filters');
        
        let counterTotal = 0;
        
        dropDownContainers?.forEach((dropDownContainer: Element) => {
            const boutonDropdown = dropDownContainer.querySelector('.js-dropdown-button');
            const counterNumber = dropDownContainer.querySelector('.nb-selected-checkbox');
            
            if (counterNumber) {
                let counter = 0;
                const allCheckbox: NodeListOf<HTMLInputElement>  = dropDownContainer.querySelectorAll('input[type=checkbox]');
                const inputDate: HTMLInputElement | null = dropDownContainer.querySelector('input[type=date]');

                allCheckbox.forEach((checkbox: HTMLInputElement) => {
                    if (checkbox.checked === true) {
                        counter++;
                    }
                });

                if (inputDate && inputDate.value != '') {
                    counter++;
                }

                if (counter > 0) {
                    counterNumber.innerHTML = counter.toString();
                    boutonDropdown?.classList.add('active');
                } else {
                    counterNumber.innerHTML = '';
                    boutonDropdown?.classList.remove('active');
                }
                counterTotal += counter;
            }
        });
        
        if (counterTotal > 0) {
            if (counterAllNumber) {
                counterAllNumber.innerHTML = counterTotal.toString();
            }
            boutonFiltresMobile?.classList.add('active');
            resetAllFiltersBtn.forEach((resetbtn: Element) => {
                resetbtn.classList.add('visible');
            });
        } else {
            if (counterAllNumber) {
                counterAllNumber.innerHTML = '';
            }
            boutonFiltresMobile?.classList.remove('active');
            resetAllFiltersBtn.forEach((resetbtn: Element) => {
                resetbtn.classList.remove('visible');
            });
        }
    }
}
